import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Video carousel',
  name: 'videoCarousel',
  type: 'object',
  fields: [
    defineField({
      title: 'Videos',
      name: 'videos',
      type: 'array',
      of: [{ type: 'youtubeVideo' }],
    }),
  ],
  preview: {
    select: {
      videos: 'videos',
    },
    prepare({ videos }) {
      let title = 'No videos'
      if (videos?.length === 1) title = `1 video`
      if (videos?.length > 1) title = `${videos.length} videos`

      return {
        title,
        subtitle: 'Video carousel',
      }
    },
  },
})